import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { ifDefined } from 'lit-html/directives/if-defined';
import Styles from './styles';

export default class AabInput extends ScopedElementsMixin(LitElement) {
  static get properties() {
    return {
      value: { type: String },
      label: { type: String },
      placeholder: { type: String },
      maxlength: { type: String },
      type: { type: String },
      required: { type: Boolean },
      invalid: { type: Boolean },
      hasFocus: { type: Boolean, attribute: 'has-focus' },
      disabled: { type: Boolean },
    };
  }

  static get scopedElements() {
    return {};
  }

  static get styles() {
    return Styles;
  }

  constructor() {
    super();
    this.label = '';
    this.placeholder = 'placeholder';
    this.type = '';
    this.hasFocus = false;
    this.disabled = false;
  }

  inputFocus() {
    this.hasFocus = !this.hasFocus;
  }

  onChange(event) {
    this.value = event.target.value;
  }

  updated() {
    const slots = this.renderRoot.querySelector("slot[name='icon']");
    const nodes = slots.assignedNodes();
    if(nodes.length) {
      slots.style.display = 'block';
    } else {
      slots.style.display = 'none';
    }
    if(this.disabled) {
      slots.classList.add('disable');
    } else {
      slots.classList.remove('disable');
    }
  }

  render() {
    return html`
      ${this.label ? html`<label for="${this.label}" class="d-inline-block col-form-label">${this.label}</label>` : ''}
      <div class="input-icon-group ${this.hasFocus ? 'focused' : ''} ${this.invalid ? 'is-invalid' : ''}">
        <input type="${this.type}"
          class="form-control"
          id="${this.label}"
          .value="${this.value}"
          placeholder="${this.placeholder}"
          ?required=${this.required}
          ?disabled=${this.disabled}
          @focusin="${() => this.inputFocus()}"
          @focusout="${() => this.inputFocus()}"
          @input="${(event) => this.onChange(event)}"
          maxlength="${ifDefined(this.maxlength ? this.maxlength : undefined)}">
        <div class="input-icon"><slot name="icon"></slot></div>
      </div>
    `;
  }
}
